module.exports = __webpack_public_path__ + "img/About_Desktop_01.3f1d706c.jpg";